import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-app-text-privacy-policy',
  templateUrl: './app-text-privacy-policy.component.html',
  styleUrls: ['./app-text-privacy-policy.component.scss'],
})
export class AppTextPrivacyPolicyComponent implements OnInit {
  language$ = this.languageService.language$;
  language: string;
  constructor(private languageService: LanguageService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  goBackToConsent() {
    this.route.queryParams.subscribe(params => {
      const returnTo = params['returnTo'] || 'consent';
      const visitor = params['visitor'];
      const visitorsFormJson = params['visitorsFormJson'];
      
      this.router.navigate(['/registration/consent', {
        visitor,
        visitorsFormJson
      }]);
    });
  }
}